import { render, staticRenderFns } from "./newShareDialog.vue?vue&type=template&id=ceef024a&scoped=true&"
import script from "./newShareDialog.vue?vue&type=script&lang=js&"
export * from "./newShareDialog.vue?vue&type=script&lang=js&"
import style0 from "./newShareDialog.vue?vue&type=style&index=0&id=ceef024a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceef024a",
  null
  
)

export default component.exports